'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _isarray = require('isarray');

var _isarray2 = _interopRequireDefault(_isarray);

var _isObject = require('is-object');

var _isObject2 = _interopRequireDefault(_isObject);

var _error = require('../error/error');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (attributes) {
  if (!(0, _isarray2.default)(attributes) && !(0, _isObject2.default)(attributes)) throw (0, _error.systemError)('Attributes is not an object or an array');
  return (0, _isarray2.default)(attributes) ? [].concat((0, _toConsumableArray3.default)(attributes)) : (0, _values2.default)((0, _extends3.default)({}, attributes));
}; // Error